import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import { GetAlbumDetailsQuery } from "@src/@types/api.d";

type Props = {
  albumDetailsData?: GetAlbumDetailsQuery;
};

const Quotes: React.FC<Props> = ({ albumDetailsData }) => {
  const text =
    "Introducing the beginning of our forever, a love story years in the making. As we prepare to say 'I do,' we are filled with gratitude for the people and moments that shaped us. This next chapter is a celebration of love, friendship, and family—and we are so glad you are part of it. Thank you for walking with us into this new adventure.";
  const [displayed, setDisplayed] = useState("");
  const [typing, setTyping] = useState(true);
  const [inView, setInView] = useState(false);
  const [randomImage, setRandomImage] = useState<any>(null);
  const containerRef = useRef(null);

  // Get random image from gallery
  useEffect(() => {
    if (albumDetailsData?.getMedia && albumDetailsData.getMedia.length > 0) {
      const mediaData = albumDetailsData.getMedia.filter(
        (image) => image && image.meta?.s3_url
      );
      if (mediaData.length > 0) {
        const randomIndex = Math.floor(Math.random() * mediaData.length);
        setRandomImage(mediaData[randomIndex]);
      }
    }
  }, [albumDetailsData]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !inView) {
          setInView(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [inView]);

  useEffect(() => {
    if (!inView) return;

    setDisplayed("");
    setTyping(true);
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed((prev) => prev + text[i]);
      i++;
      if (i >= text.length) {
        clearInterval(interval);
        setTyping(false);
      }
    }, 30);
    return () => clearInterval(interval);
  }, [inView]);

  return (
    <div
      className="bg-[rgba(236,228,237,1)] min-h-[90vh] flex flex-col justify-between items-center lg:py-[2rem]"
      ref={containerRef}
    >
      <div
        className="flex justify-center h-12 w-full relative overflow-hidden"
        style={{
          backgroundImage: `url('/images/Frame (3).svg')`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      ></div>

      {/* Mobile layout - original */}
      <div className="flex flex-col w-[88%] my-4 lg:my-10 lg:hidden">
        <h3 className="font-silver text-2xl lg:text-[30px] tracking-wider leading-loose text-center text-black">
          {displayed}
          {typing && <span className="animate-pulse">|</span>}
        </h3>
      </div>

      {/* Large screen layout - half and half */}
      <div className="hidden lg:flex lg:flex-row w-full flex-1 items-stretch">
        {/* Text half */}
        <div className="w-1/2 flex items-center justify-center px-8">
          <h3 className="font-silver text-[30px] tracking-wider leading-loose text-center text-black max-w-xl">
            {displayed}
            {typing && <span className="animate-pulse">|</span>}
          </h3>
        </div>

        {/* Image half */}
        <div className="w-1/2 relative">
          {randomImage && (
            <Image
              placeholder="blur"
              blurDataURL={`data:image/svg+xml;base64,${toBase64(
                shimmer(700, 475)
              )}`}
              src={randomImage.meta.s3_url}
              layout="fill"
              alt="gallery"
              objectFit="cover"
              className="object-center"
            />
          )}
        </div>
      </div>

      <div
        className="flex justify-center h-12 w-full relative overflow-hidden"
        style={{
          backgroundImage: `url('/images/Frame (3).svg')`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          transform: "scaleY(-1)",
        }}
      ></div>
    </div>
  );
};

export default Quotes;
